var _excluded = ["color"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { getColor } from '../Theme/selectors';
import Icon from './template';
var ArrowDown = function ArrowDown(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Icon, _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = getColor(uiTheme, color);
      }
      return /*#__PURE__*/React.createElement("path", {
        style: style,
        d: "M20,23.704762 L20,29 L4,13.6732287 L6.75575457,11 L20,23.704762 Z M20,23.704762 L33.2442454,11 L36,13.6732287 L20,29 L20,23.704762 Z"
      });
    }
  }));
};
ArrowDown.defaultProps = {
  color: null
};
export default ArrowDown;
export var name = 'ArrowDown';
export var availableProps = ['color'];